module.exports = __webpack_public_path__ + "img/modal-segment-destroy.540a6147.svg";